export default __webpack_public_path__ + "static/media/Snd_LowerGTurn.da48a9e0.mp3";